// extracted by mini-css-extract-plugin
export default {"logo":"ijYYeDVc6N_VrOlapVUT"};